import { Injectable } from '@angular/core';
import { PjesaLigjerates } from '@core/enums/pjesa-ligjerates.enum';
import { map, throwError } from 'rxjs';
import { EmriBazaForCreationDTO } from '../interfaces/dto/emri-baza-for-creation-dto.interface';
import { EmriBazaForUpdateDTO } from '../interfaces/dto/emri-baza-for-update-dto.interface';
import { EmriBazaParamsDTO } from '../interfaces/dto/emri-baza-params-dto.interface';
import { EmriBaza } from '../interfaces/models/emri-baza.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class EmriBazaService {
  private baseUrl: string = '/EmriBaza';

  constructor(private apiService: ApiService) { }

  getEmriBaza(params?: EmriBazaParamsDTO) {
    return this.apiService.get<EmriBaza[]>(`${PjesaLigjerates.Emer}${this.baseUrl}`, params);
  }

  getEmriBazaByBazaId(bazaId: number) {

    return this.apiService.get<EmriBaza[]>(`${PjesaLigjerates.Emer}${this.baseUrl}`, { bazaId: bazaId }).pipe(
      map((emriBazat) => {
        if (emriBazat.length == 0) {
          throw throwError(() => new Error('Not found'));
        }

        return emriBazat[0];
      })
    );
  }

  getEmriBazaById(id: number, params?: { fields: string }) {
    return this.apiService.get<EmriBaza>(`${PjesaLigjerates.Emer}${this.baseUrl}/${id}`, params);
  }

  insertEmriBaza(emriBaza: EmriBazaForCreationDTO) {
    return this.apiService.post<EmriBaza>(`${PjesaLigjerates.Emer}${this.baseUrl}`, emriBaza);
  }

  updateEmriBaza(emriBaza: EmriBazaForUpdateDTO) {
    return this.apiService.put<EmriBaza>(`${PjesaLigjerates.Emer}${this.baseUrl}`, emriBaza);
  }

  deleteEmriBaza(id: number) {
    return this.apiService.delete<boolean>(`${PjesaLigjerates.Emer}${this.baseUrl}/${id}`);
  }
}
